import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import {
  DoubleTextSkeleton,
  InputSkeleton,
  RiskSkeleton,
  TextSkeleton,
} from '../../../../DynamicAsset/components/AssetsLoading';

const Mobile = () => (
  <TableContent direction="column" bg={'backgroundlight'} space={Spacing['inline.xxxs']}>
    <TableContentItemColumn w={'full'} space={Spacing['inline.nano']}>
      <TextSkeleton w={'full'} h={Typography['fontsize.xl']} />
      <TextSkeleton w={'40%'} />
    </TableContentItemColumn>
    <VStack w={'full'} space={Spacing['inline.nano']}>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <TextSkeleton w={'40%'} />
        <TextSkeleton w={'40%'} />
      </HStack>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <TextSkeleton w={'40%'} />
        <TextSkeleton w={'40%'} />
      </HStack>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <TextSkeleton w={'40%'} />
        <TextSkeleton w={'40%'} />
      </HStack>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <TextSkeleton w={'40%'} />
        <RiskSkeleton />
      </HStack>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <TextSkeleton w={'40%'} />
        <TextSkeleton w={'40%'} />
      </HStack>
    </VStack>
    <VStack w={'full'} space={Spacing['inline.quarck']}>
      <TextSkeleton />
      <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
        <Box flex={1}>
          <InputSkeleton />
        </Box>
        <Skeleton
          w="40px"
          h="40px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
    </VStack>
  </TableContent>
);

const Tablet = () => (
  <TableContent direction="column" bg={'backgroundlight'} space={Spacing['inline.xxxs']}>
    <HStack
      flex={1}
      w={'full'}
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent={'space-between'}>
      <TableContentItemColumn space={Spacing['inline.quarck']} flex={2}>
        <DoubleTextSkeleton w={'90%'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton w={'50%'} />
        <RiskSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
    </HStack>
    <HStack flex={1} space={Spacing['inline.xxs']} w={'full'} alignItems={'center'}>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </HStack>
  </TableContent>
);

const Desktop = () => (
  <TableContent direction="row" bg={'backgroundlight'}>
    <TableContentItemColumn flex={0.6} space={Spacing['inline.quarck']}>
      <DoubleTextSkeleton w={'70%'} />
    </TableContentItemColumn>
    <HStack
      flex={1}
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent={'space-between'}>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton w={'50%'} />
        <RiskSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </HStack>
  </TableContent>
);

export const AddedProductItemCoesSkeleton: React.FC = () => {
  const layout = useBreakpointValue({ base: <Mobile />, sm: <Tablet />, lg: <Desktop /> });

  return layout;
};
